import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ContactCardLight from '../ContactCardLight.react';
import { isElalCompany } from '@/utils/isCompany';
import classNames from 'clsx';

class RoomContactsLight extends React.Component {
	isElal = isElalCompany();
	
	getContactCards() {
		let { reservation, count, createTravelerStatuses, disabled } = this.props;
		const { private_travel } = reservation;

		// For private travelers, only one guest per room should be displayed
		const guestsPerRoom = private_travel ? 1 : reservation.deal.guestsPerRoom;

		return _.times(guestsPerRoom, (i) => {
			const idx = guestsPerRoom * (count - 1) + i;
			const travelerCountPerRoom = private_travel ? '' : i + 1;
			const mainGuest = count === 1 && private_travel;
			const isLeadTraveller = i === 0 && idx === 0;

			return (
				<ContactCardLight
					key={`room-${count}-contact-${i + 1}`}
					reservation={reservation}
					contactIndex={idx}
					roomNumber={count}
					mainGuest={mainGuest}
					isLeadTraveller={isLeadTraveller}
					travelerCountPerRoom={travelerCountPerRoom}
					createTravelerStatus={createTravelerStatuses[idx]}
					{...(disabled ? { disabled: true } : {})}
					autoFill={this.props.autoFill}
					isElal={this.isElal}
					inlineEditTravelers={this.isElal}
				/>
			);
		});
	}

	getRoomNumber() {
		let { reservation, count } = this.props;
		return reservation.deal.rooms > 1 ? ' #' + count : null;
	}

	getRoomName() {
		const { reservation } = this.props;
		return (
			_.get(reservation, 'deal.roomMappingData.debug.room_name') ||
			_.get(reservation, 'deal.description') ||
			'-'
		);
	}

	render() {
		const { sendEmailVoucherOnlyRender, sendEmailConfirmationRender, reservation, count, t } = this.props;
		const privateTravelGuestTitle = count === 1
			? t('TravelersSection.MainGuest')
			: count === 2
				? t('TravelersSection.ExtraRooms')
				: '';
		const roomLabel = (t('TravelersSection.RoomNumber', { number: this.getRoomNumber() ?? '' }) ?? '').trim();
		const roomName = this.getRoomName().trim();

		return (
			<React.Fragment>
				{reservation.private_travel && privateTravelGuestTitle && (
					<h3 className="private-travel-guest-title">
						{privateTravelGuestTitle}
					</h3>
				)}

				<h4 className="room-name">
					{roomLabel}
					{roomName ? `: ${roomName}` : ''}
				</h4>
				
				<div className={classNames('contacts', { 'no-background': this.isElal })}>
					{this.getContactCards()}
					{sendEmailVoucherOnlyRender}
					{sendEmailConfirmationRender}
				</div>
			</React.Fragment>
		);
	}
}

RoomContactsLight.propTypes = {
	reservation: PropTypes.any,
	count: PropTypes.number,
	createTravelerStatuses: PropTypes.array,
	disabled: PropTypes.bool,
};

export default withTranslation()(RoomContactsLight);
